import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withStyles, Grid } from '@material-ui/core';
import { FHEContainerForm, FHEDivider, FHEMiniFormEditButton, FHEReactSelect } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { ApplianceIconComponent } from 'data/common/iconsvg';
import memoizeOne from 'memoize-one';
import DetailExpansionPanel from '../../../ProductModule/DetailExpansionPanel';
import DetailExpansionPanelRow from '../../../ProductModule/DetailExpansionPanelRow';
import { updateProductField } from '../../../../../../data/Products/actions';

class SDM19DE2 extends Component {
    static propTypes = {
        profile: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        filteredProductModules: PropTypes.object,
        mode: PropTypes.string,
        productType: PropTypes.string,
        type: PropTypes.string,
        productKey: PropTypes.string,
        updateProductField: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired
    };

    static defaultProps = {
        mode: null,
        filteredProductModules: null,
        productType: null,
        type: null,
        productKey: null
    };

    constructor(props) {
        super(props);
        this.state = {
            formDisabled: true,
            sendLoading: false,
            form: {
                type: null,
                brand: null,
                energyClass: null,
                label: null,
                year: null
            },
            loading: false,
            expanded: null
        };
        this.modes = [
            { value: 'triphase', label: Translator.translate('general.productModules.triphase') },
            { value: 'monophase', label: Translator.translate('general.productModules.monophase') }
        ];
    }

    static getDerivedStateFromProps(props, state) {
        const { formDisabled } = state;
        const { mode } = props;
        if (formDisabled) {
            let form = {
                mode: state.form.mode
            };
            if (props.mode !== state.form.mode) {
                form.mode = mode;
            }
            return {
                form: form,
                loading: false
            };
        } else {
            return null;
        }
    }

    handleEdit = () => {
        const { formDisabled } = this.state;
        if (formDisabled === true) {
            this.setState({
                formDisabled: false
            });
        } else {
            this.loadInputs();
            this.setState({
                formDisabled: true
            });
        }
    };

    handleChangeSelect = event => {
        const { form } = this.state;

        this.setState({
            form: { ...form, [event.target.name]: event.target.value }
        });
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    loadInputs = () => {
        const { mode } = this.props;
        this.setState({
            loading: false,
            form: {
                mode: mode
            }
        });
    };

    removeKey = (myObj, deleteKey) => {
        return Object.assign(
            {},
            ...Object.entries(myObj)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v }))
        );
    };

    confirmEdit = () => {
        const { form } = this.state;
        const { updateProductField, match, type } = this.props;

        this.setState({
            sendLoading: true,
            formDisabled: true
        });

        return updateProductField('mode', match.params.homeId, match.params.productIdentifier, match.params.productType, form.mode, type)
            .then(() => {
                Toastr.success(Translator.translate('generic.products.actions.editProductModuleSuccess'));
                this.loadInputs();
                this.setState({
                    formDisabled: true,
                    sendLoading: false
                });
            })
            .catch(() => {
                this.setState({
                    sendLoading: false,
                    formDisabled: false
                });
                Toastr.error(Translator.translate('generic.products.actions.editProductModuleError'));
            });
    };

    handleChange = panel => {
        const { expanded } = this.state;
        if (expanded === panel) {
            this.setState({
                expanded: null
            });
        } else {
            this.setState({
                expanded: panel
            });
        }
    };

    handleClick = () => {
        this.setState({
            formDisabled: false
        });
    };

    productModulesRender = lines => {
        const { productKey } = this.props;
        const { expanded } = this.state;
        let data = [];

        lines.forEach((line, key) => {
            data.push(
                <DetailExpansionPanelRow
                    key={key}
                    moduleKey={key}
                    expanded={expanded}
                    handleChange={this.handleChange.bind(this, key)}
                    line={line}
                    lineType={line.get('lineType')}
                    lineLabel={line.get('label')}
                    lineCode={line.get('code')}
                    productKey={productKey}
                />
            );
        });
        return data;
    };

    productModuleCategoriesRender = () => {
        const { filteredProductModules, theme, productType, type } = this.props;
        let data = [];

        if (filteredProductModules) {
            filteredProductModules.forEach((lines, key) => {
                data.push(
                    <DetailExpansionPanel
                        key={key}
                        headerTitle={Translator.translate(`general.productModules.${key}`)}
                        headerSvg={
                            <ApplianceIconComponent
                                productType={productType}
                                moduleType={type}
                                productLineType={key}
                                size={40}
                                color={theme.palette.common.white}
                                secondaryColor={theme.palette.primary.main}
                            />
                        }
                    >
                        {this.productModulesRender(lines)}
                    </DetailExpansionPanel>
                );
            });
        }
        return data;
    };

    getSelectedMode = memoizeOne(mode => {
        return this.modes.find(x => x.value === mode);
    });

    handleReactSelect = (event, options) => {
        const { form } = this.state;

        this.setState({
            form: { ...form, [options.name]: event.value }
        });
    };

    renderDataLoading = () => {
        const { formDisabled, form, sendLoading } = this.state;
        const { classes, profile, type } = this.props;
        const userRightUpdate = profile.get('admin') || profile.getIn(['user_rights', 'fhe'], []).includes(`products_${type}_update`);
        return (
            <Grid container spacing={3}>
                <Grid container item sm={12} md={6} lg={4} className={classes.containerMiniForm}>
                    <FHEMiniFormEditButton
                        handleEdit={this.handleEdit}
                        confirmEdit={this.confirmEdit}
                        sendLoading={sendLoading}
                        formDisabled={formDisabled}
                        hasRightToEdit={userRightUpdate}
                    >
                        <FHEReactSelect
                            name="mode"
                            label={Translator.translate('general.table.column.mode')}
                            disabled={formDisabled || !userRightUpdate}
                            onChange={this.handleReactSelect}
                            value={this.getSelectedMode(form.mode)}
                            choices={this.modes}
                        />
                    </FHEMiniFormEditButton>
                </Grid>
            </Grid>
        );
    };

    render() {
        const { loading } = this.state;
        return (
            <Fragment>
                <FHEContainerForm loading={loading} onRender={this.renderDataLoading} />
                <FHEDivider title={Translator.translate('general.productModules.title')} />
                {this.productModuleCategoriesRender()}
            </Fragment>
        );
    }
}

function productModulesFilter(productModules) {
    let filteredProductModules = new Map();
    productModules.map((productModule, productModuleKey) => {
        filteredProductModules = filteredProductModules.mergeIn([productModule.get('lineType'), productModuleKey], productModule);
    });
    return filteredProductModules;
}

function mapStateToProps(state, props) {
    const { history, productKey } = props;
    const product = state.environments[history.environment].data.Products.getIn(['list', productKey], new Map());
    const productModules = state.environments[history.environment].data.Products.getIn(['list', productKey, 'productModules'], new Map());
    return {
        profile: state.data.user,
        productKey: productKey,
        productType: product.get('productType'),
        type: product.get('type'),
        mode: product.get('mode'),
        filteredProductModules: productModulesFilter(productModules)
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    },
    containerMiniForm: {
        position: 'relative'
    }
});
export default withRouter(
    renderEnvComponent(
        'scenes/Products/components/Product/Fhe/SDM19DE2/index',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, {
                        updateProductField
                    }),
                    dispatch
                )
        )(withStyles(styles, { withTheme: true })(SDM19DE2))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Fhe/SDM19DE2/index.js